// @ts-nocheck a4457a55

export default {
  allowConnectToDB: true,
};
